import React, { useEffect, useRef, useState } from 'react';
import { Container, makeStyles, Grid, Button, Typography, Table, TableCell, TableRow, TableBody, Fade, Stepper, Step, StepLabel, colors } from '@material-ui/core';
import Page from 'components/Page';

import { FormatNumber, Header } from 'components';
import { ModalGeneral } from 'components';
// import serviciosOrden from 'utils/serviciosOrden'

import { useForm } from 'react-hook-form';
import getErrorMessage from 'utils/getErrorMessage';
import FormularioPropuesta from './FormularioPropuesta';
import FormularioSolicitud from './FormularioSolicitud';
import FormularioRequerimientos from './FormularioRequerimientos';
import serviciosCatalogo from 'utils/serviciosCatalogo';
import serviciosSolicitudes from 'utils/serviciosSolicitudes';

const useStyles = makeStyles((theme) => ({
    step: {
        "&$completed": {
            color: "rgb(76,175,80)"
        },
        "&$active": {
            color: theme.palette.primary
        },
    },
    btnAceptar: {
        color: colors.green[500],
      },
    active: {}, //needed so that the &$active tag works
    completed: {},
    // disabled: {},
}));

const actualizarEquipo = ( personas, dataGeneral, condiciones) => {
    let arrPersonas = dataGeneral.map(persona => persona.idpersona);
    if (condiciones.cond1)
        personas = personas.filter(per =>arrPersonas.includes(per.idpersona));
    return personas;
}

const Propuesta = ({setMensaje, datoS, ctls, setCargando, edicionEspecial, permisos, guardar, accion, tipo, servicios, ...props }) => {
    //inicializa variables
    const classes = useStyles();
    const formref = useRef();
    const [tabValue, setTabValue] = useState(0);
    const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: '' });
    const [ctl, setCtl] = useState({ proyectos: [], personas: datoS?.personas || [], tipoincidencias: [], responsables: [], infoarchivos: [], infoarchivosReq: [] });
    const [data, setData] = useState({general: datoS || {}, propuesta: datoS?.propuesta || [], equipo: datoS?.equipo || [] });
    const [dataReq, setDataReq] = useState({});
    const { register, unregister, handleSubmit, errors, watch, setValue, getValues, control } = useForm();
    const { register:registerProp, unregister:unregisterProp, handleSubmit:handleSubmitProp, errors:errorsProp, watch:watchProp, setValue:setValueProp, getValues:getValuesProp, control:controlProp } = useForm();
    // const { register:registerReq, unregister:unregisterReq, handleSubmit:handleSubmitReq, errors:errorsReq, watch:watchReq, setValue:setValueReq, getValues:getValuesProp, control:controlProp } = useForm();
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const fechaActual = year + '-' + month + '-' + day;
    const disponible = datoS.estatusPropuesta?(datoS.estatusPropuesta == 6?false:true):false;
    const [cambio, setCambio] = useState(false);
    const [temporal, setTemporal] = useState({});

    const cerrarAdvertencia = () => setMAdvertencia({ open: false, titulo: '' });
    const abrirAdverterncia = (mensaje, dataGeneral, condicion1) =>
        setMAdvertencia({
            open: true, mensaje: mensaje,
            aceptar: () => {
                guardarDataGeneral(dataGeneral, condicion1);
                cerrarAdvertencia();
            }
        });

    const estructuraPropuesta = (dataForm) => {
        setTabValue(2);
            setData({...data,
                equipo: dataForm.persona,
                propuesta: dataForm,
                equipoOriginal: datoS.equipo,
                proyectoOriginal: datoS.proyecto
            });
    }
    
    const rechazarPropuesta = (data)=> {
        let propModal={
          titulo: "CANCELAR PROPUESTA Y SOLICITUD",
          mensaje: "¿Está seguro de cambiar el estatus a la solicitud " + data.general.idsolicitud + "?"        
         }
        setMAdvertencia({ open: true,  edicionEspecial: false, width: "sm", paddingDisabled: false, 
          aceptar: ()=>servicios.cambioEstatus({idsolicitud: data.general.idsolicitud, idpropuesta: data.general.idpropuesta, nestatus: 0, tipo: 'rechazar'}), ...propModal
        });
      }

    const intentodataGeneral = (dataGeneral) => {
            const condicion1 = !( JSON.stringify( dataGeneral.proyecto ) == JSON.stringify( data.general?.proyecto) ); //data.general?.proyecto.includes(ids); //(dataGeneral.proyecto.idproyecto != data.general?.proyecto.idproyecto);
            if (data.equipo.length > 0 && (condicion1)) {
                let mensaje = '';
                if (condicion1)
                    mensaje = 'El proyecto ha sido actualizado, la lista de responsables se verá afectada. ¿Desea continuar?';

                abrirAdverterncia(mensaje, dataGeneral, condicion1)
            }
            else
                guardarDataGeneral(dataGeneral, condicion1);
    }

    const guardarDataGeneral = (dataGeneral, cond1) => {
        //si se esta editando o al insertar no cambio el proyecto, no se buscaran personas
        if (cond1)
            serviciosSolicitudes.personasByProy((respuesta) => {
                setCtl({ ...ctl, personas: respuesta.personas });
                setData({...data,
                    general: {
                        ...data.general,
                        proyecto: dataGeneral.proyecto,
                        presentacion: dataGeneral.presentacion?1:0,
                        bono: dataGeneral.bono,
                        nvlbono: dataGeneral.nvlbono?.value||null,
                    },
                    equipo: actualizarEquipo(data.equipo,respuesta.personas,{cond1})
                });
            }, setCargando, { idsolicitud: data.general.idsolicitud , idproyectos: dataGeneral.proyecto.map(pry => pry.idproyecto) });
        else
            setData({...data,
                general: {
                    ...data.general,
                    proyecto: dataGeneral.proyecto,
                    presentacion: dataGeneral.presentacion?1:0,
                    bono: dataGeneral.bono,
                    nvlbono: dataGeneral.nvlbono?.value||null,
                }
            });
        setTabValue(1);
    }

    const cambioPaso = (paso, nuevoData) => event => {
        setTabValue(paso);
        if(paso == 0){
                let arr = {finicio: (getValuesProp('finicio') || temporal?.finicio), ffin: (getValuesProp('ffin') || temporal?.ffin), 
                comentario: (getValuesProp('comentario') || temporal?.comentario), nhoras: (getValuesProp('nhoras') || temporal?.nhoras)}
                if(data.general.tipo_solicitud == 2)
                    arr['tipoincidencia'] = getValuesProp('tipoincidencia');
            
                if(data.general?.propuesta?.observacion)
                    arr['observacion'] = getValuesProp('observacion');

                setData({ ...data, equipo: getValuesProp('persona')?getValuesProp('persona'):[], propuesta: arr });
        }else{
            if (nuevoData)
            setData({ ...data, ...nuevoData });
        }
    }
    useEffect(() => {
            register('proyecto', {required:{ value: true, message: 'Campo requerido'} });
            register('presentacion');
            registerProp('finicio', { required: { value: true, message: 'Campo requerido' } });
            registerProp('ffin', { required: { value: true, message: 'Campo requerido' } });
            registerProp('nhoras', { required: { value: true, message: 'Campo requerido' } });
            registerProp('persona', {required:{ value: true, message: 'Campo requerido'} });
            registerProp('comentario');
            registerProp('observacion');

            if(permisos && permisos['bono']){ 
                register('bono');
                register('nvlbono', {required:{ value: true, message: 'Campo requerido'} });
            }

            if(data.general.tipo_solicitud == 2)
                registerProp('tipoincidencia', {required:{ value: true, message: 'Campo requerido'} });

        serviciosSolicitudes.ctlSolicitud((data) => {
           setCtl({ ...ctl, proyectos: data.proyectos, tipoincidencias: data.tipoincidencias, responsables: (data.responsables?data.responsables:[]), infoarchivos: data.documentos?.infoarchivos, infoarchivosReq: data.documentos?.infoarchivosReq });
        }, setCargando, {idsolicitud: datoS.idsolicitud});
    }, []);
    
    useEffect(() => {
        if(tabValue == 0){
            if(data.general?.proyecto){
                setValue('proyecto',data.general.proyecto);
                setValue('presentacion',data.general.presentacion);
                if(permisos && permisos['bono']){
                    if(data.general.bono == 0)
                        unregister('nvlbono');
                    else{
                        setValue('bono',1);
                        if(data.general.bono != null)
                            setValue('nvlbono', {value:data.general.nvlbono,label:data.general.tipo_bono}); //
                        else
                            setValue('nvlbono', null);
                    }
                }
            }else{
                    setValue('proyecto',null);
                    setValue('presentacion',null);
            }
        }

        if(tabValue == 1){
            if(data.general?.propuesta || data.equipo.length > 0 ){
                setValueProp('persona', data.equipo );
                setValueProp('finicio', data.propuesta.finicio);
                setValueProp('ffin', data.propuesta.ffin);
                setValueProp('comentario', data.propuesta.comentario);
                setValueProp('nhoras', data.propuesta.nhoras);

                if(data.general.tipo_solicitud == 2){
                    setValueProp('tipoincidencia', data.propuesta.tipoincidencia);
                }

                if(data.propuesta.observacion){
                    setValueProp('observacion',data.propuesta.observacion);
                }
                    
            }else{
                if( Object.keys(temporal).length> 0){
                    setValueProp('persona', temporal?.persona || null);
                    setValueProp('finicio', temporal?.finicio || fechaActual || null);
                    setValueProp('ffin', temporal?.ffin || null);
                    setValueProp('comentario', temporal?.comentario || null);
                    setValueProp('nhoras', temporal?.nhoras || null);
                    setValueProp('observacion', temporal?.observacion || null);

                    if(temporal?.tipo_solicitud == 2)
                        setValueProp('tipoincidencia', temporal?.tipo_solicitud || null);
                }else{
                    setValueProp('persona', null);
                    setValueProp('finicio', fechaActual);
                    setValueProp('ffin', null);
                    setValueProp('nhoras', null);
                    setValueProp('comentario', null);
                    setValueProp('observacion', null);

                    if(data.general.tipo_solicitud == 2)
                        setValueProp('tipoincidencia', null);
                }
            }
        }
    }, [tabValue, data]);
    return (
        <Container maxWidth={false}>
            <Stepper activeStep={tabValue} orientation="horizontal">
                <Step>
                    <StepLabel
                        StepIconProps={{
                            classes: {
                                root: classes.step,
                                completed: classes.completed,
                                active: classes.active,
                                disabled: classes.disabled
                            }
                        }}
                    >DATOS DE LA SOLICITUD</StepLabel>
                </Step>
                <Step key={1}>
                    <StepLabel
                        StepIconProps={{
                            classes: {
                                root: classes.step,
                                completed: classes.completed,
                                active: classes.active,
                                disabled: classes.disabled
                            }
                        }}
                    // optional={orden
                    //     ? <Typography variant="caption">({orden.fmodificaInsumo})</Typography>
                    //     : undefined}
                    >PROPUESTA</StepLabel> {/* {(permisos && permisos['requerimientos']?'REQUERIMIENTOS':'PROPUESTA')}*/}
                </Step>
                <Step key={2}
                    StepIconProps={{
                        classes: {
                            root: classes.step,
                            completed: classes.completed,
                            active: classes.active,
                            disabled: classes.disabled
                        }
                    }}>
                    <StepLabel>GUARDAR PROPUESTA</StepLabel>  {/** {(permisos && permisos['requerimientos']?'GUARDAR REQUERIMIENTOS':'GUARDAR PROPUESTA')} */}
                </Step>
            </Stepper>
            <Fade in={tabValue === 0} style={{ display: tabValue === 0 ? 'block' : 'none' }}>
                <Container>
                    <form autocomplete="off" onSubmit={handleSubmit(intentodataGeneral)}>
                        <FormularioSolicitud
                            register={register}
                            errors={getErrorMessage(errors)}
                            watch={watch}
                            ctlg={{ ...ctls, proyectos: ctl.proyectos, responsables: ctl.responsables, infoarchivos:ctl.infoarchivos, infoarchivosReq:ctl.infoarchivosReq }}
                            isEdicion={disponible}
                            // bucarEquipo={bucarEquipo}
                            defaultItem={data || {}} unregister={unregister}
                            setValue={setValue} permisos={permisos}
                            getValues={getValues} control={control}
                            setCargando={setCargando}
                        />
                        <Grid item container justify="flex-end">
                            <Button type="submit" className={classes.btnAceptar} ref={formref} style={{  textAlign: 'end' }}>Siguiente</Button>
                        </Grid>
                    </form>
                </Container>
            </Fade>
            <Fade in={tabValue === 1} style={{ display: tabValue === 1 ? 'block' : 'none' }}>
                <Container>
                    <form autocomplete="off" onSubmit={handleSubmitProp(estructuraPropuesta)}>
                        {data.general?.proyecto && tabValue === 1 &&
                            <FormularioPropuesta
                                register={registerProp}
                                errors={getErrorMessage(errorsProp)}
                                watch={watchProp}
                                ctlg={{ ...ctls, personas: ctl.personas, tipoincidencias: ctl.tipoincidencias }}
                                isEdicion={disponible}
                                defaultItem={data || {}}
                                setValue={setValueProp} setCambio={setCambio}
                                getValues={getValuesProp} control={controlProp}
                                permisos={permisos}
                                setTemporal={setTemporal}
                                temporal={temporal}
                            />
                         } {/* {(permisos && permisos['requerimientos'])?
                         <FormularioRequerimientos
                             register={registerProp}
                             errors={getErrorMessage(errorsProp)}
                             watch={watchProp}
                             setValue={setValueProp}
                             control={controlProp}
                             />
                         : */}
                        <Grid item container justify="space-between">
                            <Button color="secondary" onClick={cambioPaso(0,{equipo:data?.equipo})}>REGRESAR</Button>
                            <Button type="submit" ref={formref} className={classes.btnAceptar} style={{  textAlign: 'end' }}>Siguiente</Button>
                        </Grid>
                    </form>
                </Container>
            </Fade>
            <Fade in={tabValue === 2} style={{ display: tabValue === 2 ? 'block' : 'none' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                        <Typography variant="subtitle1" style={{ margin: 'auto' }}>
                            Favor de verificar que todos los datos son correctos antes de guardar
                        </Typography>
                    </Grid>
                    {tabValue === 2 &&<Grid container spacing={2}>
                        <React.Fragment>
                            <Grid item xs={6} md={6}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell variant="head" >SOLICITUD # {data.general.idsolicitud}</TableCell>
                                            <TableCell variant="body" colSpan={3} >{data.general.titulo}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell variant="head" colSpan={4}  style={{textAlign:"center"}} >PROPUESTA: {data.propuesta.nhoras} horas de trabajo</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell variant="head" >FECHA DE INICIO</TableCell>
                                            <TableCell variant="body" >{data.propuesta.finicio}</TableCell>
                                            <TableCell variant="head" >FECHA DE TÉRMINO</TableCell>
                                            <TableCell variant="body" >{data.propuesta.ffin}</TableCell>
                                        </TableRow>
                                        <React.Fragment>
                                            {data.equipo.map((persona, index)=>(
                                                <TableRow>
                                                    <TableCell variant="head" > {(index == 0 ? 'MIEMBROS DEL EQUIPO' : '')}</TableCell>
                                                    <TableCell variant="body" colSpan={3} >{persona.npersona}</TableCell>
                                                </TableRow>
                                            ))}
                                        </React.Fragment>
                                    </TableBody>
                                </Table>
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell variant="head" style={{textAlign:"center"}}>ACTIVIDADES A DESARROLLAR</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell variant="body" >{data.propuesta.comentario}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Grid>
                        </React.Fragment>
                        {/** (permisos && permisos['requerimientos']) ? <React.Fragment>
                            <Grid item xs={12} md={12}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell variant="head" >SOLICITUD # {data.general.idsolicitud}</TableCell>
                                            <TableCell variant="body" colSpan={3} >{data.general.titulo}</TableCell>
                                            <TableCell variant="head" >RESPONSABLE</TableCell>
                                            <TableCell variant="body" >{dataReq.responsable.npersona}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell variant="head" style={{textAlign:"center"}}>REQUERIMIENTOS</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell variant="body" >Aplicar requerimientos: {dataReq.aplicarReq?'Sí':'No'}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Grid>
                        </React.Fragment>
                        : */}
                    </Grid>}
                    <Grid item container justify="space-between">
                        <Button variant="text" color="secondary" className onClick={cambioPaso(1)}>Regresar</Button>
                        {(permisos&&permisos['rechazar']) && <Button variant="text" color="primary" onClick={()=>rechazarPropuesta(data)}>Cancelar propuesta</Button>}
                        {(permisos&&permisos['guardarProp'])?
                                (cambio == true? 
                                    <React.Fragment> 
                                        <Button variant="text" color="primary" onClick={()=>guardar(data, cambio, 'gerente')}>{'Regresar a gerente'}</Button>
                                        <Button variant="text" color="primary" onClick={()=>guardar(data, cambio, 'directo')}>{'Comenzar desarrollo'}</Button>
                                    </React.Fragment>
                                    : <Button variant="text" color="primary" onClick={()=>guardar(data, cambio, 'directo')}>{'Comenzar desarrollo'}</Button>)
                            :<Button variant="text" color="primary" onClick={()=>guardar(data, cambio, 'directo')}>{'Guardar Propuesta'}</Button>}
                         {/** permisos && permisos['requerimientos'])?guardar(dataReq):  || (permisos && permisos['requerimientos']) ?'Guardar':*/}
                    </Grid>
                </Grid>
            </Fade>
            <ModalGeneral
                open={mAdvertencia.open}
                titulo='Advertencia'
                width='sm'
                ContenidoMensaje={mAdvertencia.mensaje}
                acciones={<React.Fragment>
                    <Button className="btnError" color="secondary" onClick={cerrarAdvertencia}>CERRAR</Button>
                    {Boolean(mAdvertencia.aceptar) &&
                        <Button color="primary" style={{color:colors.green[500]}} onClick={mAdvertencia.aceptar}>ACEPTAR</Button>
                    }
                </React.Fragment>}
            />
        </Container>
    );
};

export default Propuesta;